import { render, staticRenderFns } from "./CRMPreferential.vue?vue&type=template&id=4ecddefc&scoped=true"
import script from "./CRMPreferential.vue?vue&type=script&lang=js"
export * from "./CRMPreferential.vue?vue&type=script&lang=js"
import style0 from "./CRMPreferential.vue?vue&type=style&index=0&id=4ecddefc&prod&scoped=true&lang=css"
import style1 from "./CRMPreferential.vue?vue&type=style&index=1&id=4ecddefc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ecddefc",
  null
  
)

export default component.exports